/**
 * The moderator room's place in the dashboard. Under the web, so `/company/:id/workspace/:id/` keeps the app-wide
 * hooks (capabilities, company context) working, and a sibling of the web's tabs rather than one of them: the room is
 * full screen, with no workspace shell around it. The classic header's Open room links here.
 */
export const ROOM_ROUTE = '/company/:clientCompanyId/workspace/:workspaceId/campaign/:campaignId/web/:webId/live'

const ROOM_PATH = /\/campaign\/[^/]+\/web\/[^/]+\/live(\/|$)/

/**
 * Is this path the moderator room? The app keeps its floating Webster widget off it, and its 422 toast: the room
 * reports its refusals inline, in the console's design, like the console does.
 */
export function isRoomPath(path: string | undefined | null): boolean {
    return !!path && ROOM_PATH.test(path)
}
